<template>
  <div
    v-loading.lock="loading"
    class="ad1-container"
    :class="{'mt-custom-75': !isMobile}"
  >
    <bread-crumb
      v-if="!isMobile && item.category"
      :category="item.category.parent || item.category"
      :subcategory="item.category.parent ? item.category : null"
    />
    <div class="ad-wrapper container">
      <div
        v-if="isMobile"
        class="carousel"
      >
        <router-link
          :to="{ name: 'Home' }"
          class="back"
          tag="button"
        >
          <i class="icon-arrow-b" />
        </router-link>
        <el-button
          class="share"
          icon="icon-share"
          @click="openShareModal = true"
        />
        <favorite
          v-model="item.favoring_logged_in_user"
          :res="'ads/favourite'"
          :entity-id="item.id"
          :entity-name="'ad_id'"
        />
        <span class="views"><i class="icon-eye" />{{ item.viewers_count }}</span>
        <el-carousel
          v-if="files && files.length"
          :interval="5000"
          :arrow="files && files.length > 1 ? 'always' : 'never'"
          :indicator-position="files && files.length > 1 ? 'inside' : 'none'"
        >
          <el-carousel-item
            v-for="itemFile in files"
            :key="itemFile.src"
          >
            <vue-load-image>
              <img
                slot="image"
                class="carousel-img"
                :src="itemFile.src | resizeImage(767, 498)"
                :data-src="itemFile.src | resizeImage(767, 498)"
                @click="test"
              >
              <div
                slot="preloader"
                v-loading="true"
                class="img-loading"
              >
                {{ $t('Loading ....') }}
              </div>
              <div slot="error">
                {{ $t('Network error') }}
              </div>
            </vue-load-image>
          </el-carousel-item>
        </el-carousel>
        <el-carousel
          v-else
          :interval="5000"
          arrow="always"
        >
          <el-carousel-item class="no-image-found">
            <img
              class="carousel-img"
              src="../assets/no-image.png"
            >
          </el-carousel-item>
        </el-carousel>
        <h3
          v-if="item.price"
          class="ad1-price"
        >
          {{ item.price ? item.price : '' | formatMoney(0) }} {{ item.currency ? item.currency.code : '' }}
        </h3>
        <span class="title"> {{ item.name }}</span>
      </div>
      <div class="user-ad">
        <template v-if="!isMobile && activeImage">
          <vue-load-image class="main-preview-image">
            <img
              slot="image"
              class="img-responsive"
              :src="activeImage | resizeImage(1146, null, true)"
              :data-src="activeImage"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
          <!--<img v-if="activeImage" class="main-image" :src="activeImage | resizeImage(573, 375)">-->
        </template>
        <lightbox
          v-if="files && files.length"
          id="mylightbox"
          ref="mylightbox"
          :class="{'mobile-lightbox': isMobile}"
          :images="files"
        >
          <el-button
            v-if="!isMobile"
            class="view"
          >
            {{ $t('ad.item.view-all') }}<i class="icon-copy" />
          </el-button>
        </lightbox>
        <div class="ad1-details">
          <div
            v-if="!isMobile && item && item.files && item.files.length"
            class="ad1-image"
          >
            <vue-load-image>
              <img
                v-for="image in files"
                slot="image"
                :key="image.src"
                class="image"
                clickable
                :src="image.src | resizeImage(70, 70)"
                :data-src="image.src | resizeImage(70, 70)"
                @click="changeActiveImage(image.src)"
              >
              <div
                slot="preloader"
                v-loading="true"
                class="img-loading"
              >
                {{ $t('Loading ....') }}
              </div>
              <div slot="error">
                {{ $t('Network error') }}
              </div>
            </vue-load-image>
          </div>
          <div class="ad1-box">
            <template v-if="!isMobile">
              <div
                class="views"
              >
                <i class="icon-eye" />
                <span>{{ item.viewers_count }}</span>
              </div>
              <div
                class="share"
              >
                <i
                  class="icon-share"
                  @click="openShareModal = true"
                />
              </div>
              <favorite
                v-model="item.favoring_logged_in_user"
                :res="'ads/favourite'"
                :entity-id="item.id"
                :entity-name="'ad_id'"
              />
            </template>
            <div
              v-if="isMobile && item.user"
              class="user-details"
              @click="viewUser"
            >
              <div class="image">
                <vue-load-image v-if="item.user.file">
                  <img
                    slot="image"
                    :src="item.user.file.url_view | resizeImage(300, 300)"
                    :data-src="item.user.file.url_view | resizeImage(300, 300)"
                  >
                  <div
                    slot="preloader"
                    v-loading="true"
                    class="img-loading"
                  >
                    {{ $t('Loading ....') }}
                  </div>
                  <div slot="error">
                    {{ $t('Network error') }}
                  </div>
                </vue-load-image>
                <img
                  v-else
                  src="../assets/profile-default.png"
                >
              </div>
              <h3 class="user-name">
                {{ item.user.name }}
              </h3>
            </div>
            <div class="about-ad">
              <!--<social-sharing :url="shareUrl" :networks="overriddenNetworks" inline-template>-->
              <!--<div>-->
              <!--<network network="facebook">-->
              <!--<i class="fa fa-fw fa-facebook"></i> Facebook-->
              <!--</network>-->
              <!--<network network="messenger">-->
              <!--<i class="fa fa-fw fa-google-plus"></i> Messenger-->
              <!--</network>-->
              <!--<network network="twitter">-->
              <!--<i class="fa fa-fw fa-twitter"></i> Twitter-->
              <!--</network>-->
              <!--<network network="email">-->
              <!--<i class="fa fa-fw fa-twitter"></i> Email-->
              <!--</network>-->
              <!--<network network="gMail">-->
              <!--<i class="fa fa-fw fa-twitter"></i> gMail-->
              <!--</network>-->
              <!--<network network="whatsapp">-->
              <!--<i class="fa fa-vk"></i> WhatsApp-->
              <!--</network>-->
              <!--</div>-->
              <!--</social-sharing>-->
              <div class="custom-info">
                <h3
                  v-if="!isMobile"
                  class="title"
                >
                  {{ item.name }}
                </h3>
                <h2
                  v-if="!isMobile && item.price > 0"
                  class="price"
                >
                  {{ item.price ? item.price : '' | formatMoney(0) }} {{ item.currency ? item.currency.code : '' }}
                </h2>
              </div>
              <span
                v-if="item.publish_date"
                class="date"
              >{{ formatedDate(item.publish_date) }}</span>
            </div>
            <div class="tags">
              <div
                v-if="item.contact_info"
                class="tag"
              >
                <i class="icon-place" />{{ item.contact_info.location }}
              </div>
              <div
                v-for="tag in item.attribute_values"
                :key="tag.id"
              >
                <button
                  v-if="tag.attribute_type && tag.attribute_type.name"
                  :class="{active: activeId === tag.id}"
                  class="tag tag-button"
                  @click="activate(tag.id)"
                >
                  {{ tag.attribute_type.name }}: {{ tag.value | formatTag }}
                </button>
              </div>
            </div>
            <div v-if="!isMobile">
              <h4 class="message">
                {{ $t('ad.item.message.text') }}
              </h4>
              <div class="message-input">
                <span
                  class="input-label"
                  @click="sendLastPriceMessage($t('ad.item.last.price.text'))"
                >{{ $t('ad.item.last.price.text') }}</span>
                <send-message
                  :last-price="lastPriceMessage"
                  :small-input="true"
                  :append-data="sendMessageData"
                  @done="messageSent"
                />
              </div>
            </div>
          </div>
          <div
            class="ad1-description ql-editor"
            v-html="item.description"
          />
          <GmapMap
            v-if="isMobile && item.contact_info"
            class="google-map"
            :center="{ lat: Number(item.contact_info.latitude), lng: Number(item.contact_info.longitude) }"
            :zoom="maps.zoom"
            :options="maps.options"
            map-type-id="terrain"
          >
            <GmapMarker
              :position="{ lat: Number(item.contact_info.latitude), lng: Number(item.contact_info.longitude) }"
            />
          </GmapMap>
<!--          <a-->
<!--            v-if="isMobile"-->
<!--            href="https://lemoonline.com"-->
<!--            target="_blank"-->
<!--            class="advertisement"-->
<!--          >-->
<!--            <img :src="`/static/img/ad/mobile/${locale}.jpg`">-->
<!--          </a>-->
<!--          <div v-if="isMobile">-->
<!--            <vue-adsense-->
<!--              v-if="adSlot"-->
<!--              :ad-slot="adSlot"-->
<!--            />-->
<!--          </div>-->
          <div v-if="isMobile && item.user && item.user.id">
            <entity-list
              ref="entityList"
              res="ads"
              :filter="getRequestFilters || []"
              :sort="[['publish_date', 'desc']]"
              :res-options="relatedResourceOptions"
              :post-on-index="false"
            >
              <template
                slot="list"
                slot-scope="{ list }"
              >
                <el-tabs>
                  <el-tab-pane :label="$t('ad.other.seller.text')">
                    <el-col
                      v-for="adItem in list"
                      :key="`ad_item_mobile_${adItem.id}`"
                      class="col-item"
                      :span="12"
                    >
                      <ads-item
                        :item="adItem"
                        :is-ad="true"
                      />
                    </el-col>
                  </el-tab-pane>
                </el-tabs>
              </template>
            </entity-list>
          </div>
          <div v-if="!isMobile && item.user && item.user.id">
            <entity-list
              ref="entityList"
              res="ads"
              :filter="getRequestFilters || []"
              :sort="[['publish_date', 'desc']]"
              :res-options="relatedResourceOptions"
              :post-on-index="false"
            >
              <template
                slot="list"
                slot-scope="{ list }"
              >
                <span class="user-ads">{{ $t('ad.other.seller.ads.text') }}</span>
                <div class="ads1-list">
                  <ads-row
                    v-for="adItem in list"
                    :key="`ad_item_desktop_${adItem.id}`"
                    :param-item="adItem"
                  />
                </div>
              </template>
            </entity-list>
          </div>
        </div>
      </div>
      <div
        v-if="!isMobile && item.user"
        class="user-details"
      >
        <el-button
          v-if="!user"
          class="message"
          @click="toLogin"
        >
          <i class="icon-massage" />{{ $t('ad.write-message.text') }}
        </el-button>
        <el-button
          v-else-if="user && user.id !== item.user.id"
          class="message"
          @click="writeMessage.show = true"
        >
          <i class="icon-massage" />{{ $t('ad.write-message.text') }}
        </el-button>
        <el-button
          v-else
          class="message"
          disabled
          @click="writeMessage.show = true"
        >
          <i class="icon-massage" />{{ $t('ad.write-message-disabled.text') }}
        </el-button>
        <el-button
          v-if="item.contact_info "
          class="phone"
          @click="phoneShow"
        >
          <span v-if="showPhone">
            <i class="icon-phone-receiver" />{{ item.contact_info.phone }}
          </span>
          <span v-else>
            <i class="icon-phone-receiver" />{{ item.contact_info.phone | phone }}
          </span>
        </el-button>
        <div class="user-card">
          <GmapMap
            v-if="item.contact_info"
            class="google-map"
            :center="{ lat: Number(item.contact_info.latitude), lng: Number(item.contact_info.longitude) }"
            :zoom="maps.zoom"
            :options="maps.options"
            map-type-id="terrain"
          >
            <GmapMarker
              :position="{ lat: Number(item.contact_info.latitude), lng: Number(item.contact_info.longitude) }"
            />
          </GmapMap>
          <div
            v-else
            class="custom-margin-top"
          />
          <div
            class="image"
            clickable
            @click="viewUser"
          >
            <vue-load-image v-if="item.user.file">
              <img
                slot="image"
                :src="item.user.file.url_view | resizeImage(300, 300)"
                :data-src="item.user.file.url_view | resizeImage(300, 300)"
              >
              <div
                slot="preloader"
                v-loading="true"
                class="img-loading"
              >
                {{ $t('Loading ....') }}
              </div>
              <div slot="error">
                {{ $t('Network error') }}
              </div>
            </vue-load-image>
            <img
              v-else
              src="../assets/profile-default.png"
            >
          </div>
          <div class="user-description">
            <h3
              v-if="item.user"
              class="title"
              clickable
              @click="viewUser"
            >
              {{ item.user.name }}
            </h3>
            <span
              v-if="item.user"
              class="time"
            >{{ $t('ad.user.last-seen.text') }} {{ formatedDate(item.user.last_seen) }}</span>
            <el-button
              class="all-ads"
              @click="viewUser"
            >
              {{ $t('ad.user.all-ads.text') }}
            </el-button>
          </div>
        </div>
<!--        <a-->
<!--          href="https://youtube.com/c/AwazApp"-->
<!--          target="_blank"-->
<!--          class="advertisement"-->
<!--        >-->
<!--          <img :src="`/static/img/ad/desktop/${locale}.jpg`">-->
<!--        </a>-->
        <!--        <vue-adsense-->
        <!--          v-if="adSlot"-->
        <!--          :ad-slot="adSlot"-->
        <!--        />-->
      </div>
    </div>
    <menu-contact-user
      v-if="item.contact_info && isMobile"
      :is-label="true"
      :show-message-box="user && user.id !== item.user.id"
      :phone="item.contact_info.phone"
      :append-data="sendMessageData"
      @done="messageSent"
      @sendLastPrice="sendLastPriceMessage($t('ad.item.last.price.text'))"
    />
    <el-dialog
      class="categories custom-message"
      :title="$t('write-message.dialog.title')"
      :visible.sync="writeMessage.show"
      width="900px"
      center
    >
      <send-message
        :append-data="sendMessageData"
        @done="messageSent"
      />
    </el-dialog>
    <el-dialog
      class="custom-message custom-addthis"
      :visible.sync="openShareModal"
      width="300px"
      center
    >
      <div
        :class="addThisClass"
        :data-url="shareUrl"
        :data-title="item.title"
        :data-description="item.description"
        :data-media="activeImage"
      />
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import BreadCrumb from '../components/BreadCrumb';
import AdsRow from '../components/Ads/AdsRow';
import AdsItem from '../components/Ads/AdsItem';
import MenuContactUser from '../components/Mobile/MenuContactUser';
import ResourcePage from '../components/Core/ResourcePage';
import Lightbox from '../components/Lightbox';
import Favorite from '../components/Core/Favorite';
import SendMessage from '../components/Ads/SendMessage';
import diffForHumans from '../filter/diff-for-humans';
import formatDate from '../filter/format-date';
import EntityList from '@/components/Core/EntityList'
// import VueAdsense from "@/components/VueAdsense";
Vue.prototype.lazyLoadPackages.addThis.load();

export default {
  components: {
    EntityList,
    // SocialShareAddThis,
    MenuContactUser,
    AdsItem,
    AdsRow,
    BreadCrumb,
    Lightbox,
    Favorite,
    SendMessage
    // VueAdsense,
  },
  extends: ResourcePage,
  data() {
    return {
      openShareModal: false,
      overriddenNetworks: {
        messenger: {
          sharer: 'https://www.messenger.com/',
          type: 'popup',
        },
        gMail: {
          sharer: 'https://mail.google.com/',
          type: 'popup',
        },
      },
      showMobile: true,
      lastPriceMessage: '',
      countClick: 0,
      showPhone: false,
      activeId: null,
      resource: 'ads',
      autoload: true,
      resourceOptions: {
        files: true,
        contact_info: true,
        user: true,
        'user:file': true,
        'category:parent': true,
        currency: true,
        'attribute_values:attribute_type': true,
        favoring_logged_in_user: true,
      },
      relatedResourceOptions: {
        file: true,
        favoring_logged_in_user: true,
        contact_info: true,
        currency: true,
        'category:parent': true,
      },
      activeImage: null,
      window,
      writeMessage: {
        show: false,
      },
      ad: {
        badge: 1564,
      },
      maps: {
        zoom: 14,
        options: {
          fullscreenControl: false,
          mapTypeControl: false,
          panControl: false,
          rotateControl: false,
          streetViewControl: false,
          zoomControl: false,
        },
      },
    };
  },
  computed: {
    ...mapState({
      addThisClass: state => state.config.addThisShareClass,
      isMobile: state => state.isMobile,
      locale: state => state.locale,
      user: state => state.auth.user,
      url: state => state.config ? state.config.apiUrl.replace('/api', '') : '',
      adSlot: state => state.config.adSlot && state.config.adSlot.adView ? state.config.adSlot.adView[0] : null,
      getRequestFilters () {
        return [{
          property: 'active',
          operator: '=',
          value: true,
        }, {
          property: 'id',
          operator: '!=',
          value: this.item.id
        }, {
          property: 'user_id',
          operator: '=',
          value: this.item.user.id
        }]
      }
    }),
    files() {
      return this.item && this.item.files && this.item.files.length ?
        this.item.files.map(item => ({
          src: item.url_view,
          title: item.name,
        })) : [];
    },
    sendMessageData() {
      return this.user && this.item ? {
        user_id: this.user.id,
        ad_id: this.item.id,
      } : null;
    },
    shareUrl() {
      return `${this.url}/?ad_id=${this.item.id}#/ad/${this.item.id}`;
    },
  },
  watch: {
    item(item) {
      if (item.files && item.files.length) {
        this.activeImage = item.files[0].url_view;
      } else {
        this.activeImage = '/static/img/no-image.png';
      }

      this.$nextTick(() => {
        if (this.$refs.entityList) {
          this.$refs.entityList.doRefresh()
        }
      })
    },
    openShareModal(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (typeof window.addthis !== 'undefined') {
            window.addthis.layers.refresh();
          }
        });
      }
    },
    '$route.params': {
      immediate: true,
      handler() {
        if (window && window.scroll) {
          window.scroll(0, 0);
        }
      },
    },
  },
  methods: {
    test() {
      this.$refs.mylightbox.toggleLightbox(true);
    },
    formatedDate(date) {
      const endDate = moment(new Date());
      const duration = moment.duration(endDate.diff(date));
      const diffDays = duration.asDays();
      return diffDays < 6 ? diffForHumans(date, this.locale) : formatDate(date, 'D MMMM Y', this.locale);
    },
    sendLastPriceMessage(message) {
      this.lastPriceMessage = message !== this.lastPriceMessage ? message : this.lastPriceMessage;
    },
    toLogin() {
      this.$router.push({ name: 'Login' });
    },
    phoneShow() {
      if (this.showPhone === false) {
        this.showPhone = !this.showPhone;
      }
      // else {
      //   this.showPhone = !this.showPhone;
      //   window.open(`tel://${this.item.contact_info.phone}`, '_blank');
      // }
    },
    activate(id) {
      this.activeId = id;
    },
    changeActiveImage(url) {
      this.activeImage = url;
    },
    viewUser() {
      this.$router.push({ name: 'Profile', params: { id: this.item.user.id } });
    },
    messageSent() {
      this.writeMessage.show = false;
      this.$message({
        showClose: true,
        message: this.$t('message.success'),
        type: 'success',
      });
    },
    share() {
      if (navigator && navigator.share) {
        this.loading = true;
        navigator
          .share({ url: window.location.href })
          .then(() => { this.loading = false; })
          .catch(() => { this.loading = false; });
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Ad.vue